import type { HostClientType } from '@ms/yammer-web-support/dist/metaOsHub';
import { MetaOsHubHostName, isSafeToCachePersonalData } from '@ms/yammer-web-support/dist/metaOsHub';
import type { AppLaunchInitiator } from '@ms/yammer-web-support/dist/teams/deeplinks/types';

import { teamsContextStore } from './teamsContextStore';
import type { TeamsContext, TeamsThemeType } from './types';

export const getTeamsContext = (): TeamsContext | undefined => teamsContextStore.getState().teamsContext;

export const getTheme = (): TeamsThemeType => {
  const teamsContext = getTeamsContext();

  return teamsContext ? teamsContext.theme : 'default';
};

export const getIsSafeToCachePersonalDataToStorage = (): boolean => {
  const hostClientType = getHostClientType();

  return isSafeToCachePersonalData(hostClientType);
};

export const getHostClientType = (): HostClientType | undefined => getTeamsContext()?.hostClientType;

export const isWebClient = (): boolean => {
  const hostClientType = getTeamsContext()?.hostClientType;

  return hostClientType === 'web';
};

export const isTeamsDesktopClient = (): boolean => isTeamsHub() && getTeamsContext()?.hostClientType === 'desktop';

export const getDeepLinkPath = (): string | undefined => getTeamsContext()?.deepLinkPath;

export const getAppLaunchInitiator = (): AppLaunchInitiator => {
  const deepLinkPath = getDeepLinkPath();

  if (deepLinkPath) {
    if (deepLinkPath.includes('publisherOpen=true')) {
      return 'universal_create_button';
    }

    return 'activity_bar';
  }

  return 'chat_tab';
};

export const getMetaOsHostAppName = (): MetaOsHubHostName | undefined => getTeamsContext()?.hostAppName;

export const getUserClickTime = (): number | undefined => getTeamsContext()?.userClickTime;

export const isTeamsHub = (): boolean => {
  const hostAppName = getMetaOsHostAppName();

  return hostAppName === MetaOsHubHostName.teamsModern || hostAppName === MetaOsHubHostName.teams;
};

export const getEntityId = (): string | undefined => getTeamsContext()?.entityId;

export const isTeamsCached = (): boolean => teamsContextStore.getState().teamsCachingContext.isCached;

export const isBackgroundLoad = (): boolean => !!getTeamsContext()?.isBackgroundLoad;
